module.exports = __webpack_public_path__ + "static/media/photo203.a77c690e.jpg";